import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    currencyList: [],
    detailDialogVisible: false,
    currencyDetail: {
      info: {},
      eosSerious: false,
      eosSeriousConfig: {}
    },
    pagination: PAGINATION,
    totalCount: 0,
    spriteUrl: '',
    logoInfo: [],
    chainsData:[],
    udData:[],
    sourceAddressData:[],
  },
  getters: {
    currencyList: state => state.currencyList
  },
  mutations: {
    setCurrencyList(state, payload) {
      state.currencyList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setCurrencyDetail(state, payload) {
      state.currencyDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setSpriteUrl(state, payload) {
      state.spriteUrl = payload;
    },
    setLogoInfo(state, payload) {
      state.logoInfo = payload;
    },
    setChainData(state, payload) {
      state.chainsData = payload.slice();
    },
    setUdData(state, payload) {
      if(payload!=null){
        const arr = payload.map(item=>{
          return {code:item.code,name:item.coinFullName}
        });
        state.udData=[...arr]
      }else{
        state.udData=[]
      }
    
   
    },
    setSourceAddressData(state, payload) {
      state.sourceAddressData = payload.slice();
    },
  },
  actions: {
    list({ commit }, { code, page, size, areaType }) {
      api.getCurrencyList({ code, page, size, areaType }).then(({ data }) => {
        commit('setPagination', { page, size });
        commit('setCurrencyList', data);
      });
    },
    getChains({commit}){
      api.getChains().then(res=>{
        commit('setChainData',res.data)
      })
    },
    getUdList({commit}){
      api.getUdList().then(res=>{
        commit('setUdData',res.data)
      })
    },
    getSourceAddress({commit}){
      api.getSourceAddress().then(res=>{
        commit('setSourceAddressData',res.data)
      })
    },
    // eslint-disable-next-line
    updateDepositStatus({ commit }, data) {
      return new Promise(resolve => {
        api.updateDepositStatus(data).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    updateWithdrawStatus({ commit }, data) {
      return new Promise(resolve => {
        api.updateWithdrawStatus(data).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    create({ commit }, currency) {
      return new Promise(resolve => {
        api.createCurrency(currency).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    update({ commit }, currency) {
      return new Promise(resolve => {
        api.updateCurrency(currency).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    remove({ commit }, {code,chain}) {
      return new Promise(resolve => {
        api.removeCurrency({code,chain}).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    updateTradeStatus({ commit }, data) {
     
      return api.updateTradeStatus(data);
    },
    updateDisplayStatus(context, data) {
      return api.updateDisplayStatus(data);
    },
    updateAreaType(context, data) {
      return api.updateAreaType(data);
    },
    updateSort(context, data) {
      return api.updateSort(data);
    },
    detail({ commit }, {coinType,chain}) {
     return api.detail({coinType,chain}).then(({ data }) => {
        commit('setCurrencyDetail', data);
        return data
      });
    },
    getLogoInfo({ commit }) {
      api.getCoinLogoInfo().then(({ data }) => {
        commit('setSpriteUrl', data.url);
        commit('setLogoInfo', data.coinLogoInfoList);
      });
    },
    updateLogoInfo(context, data) {
      return api.updateCoinLogoInfo(data);
    },
    updateRedPacketStatus(context, data) {
      return api.updateRedPacketStatus(data);
    }
  }
};

appStore.registerModule('currencySetting', store);
